const role = [
  { role: 'front', title: 'พนักงานหน้าร้าน' },
  { role: 'member', title: 'พนักงานทั่วไป' },
  { role: 'superuser', title: 'ผู้ดูแลระบบ' },
  { role: 'Administrator', title: 'ผู้ดูแลระบบ'}
]

export const ROLE = role.reduce((map, obj) => {
  map[obj.role] = obj.title;
  return map;
}, {});

export default role



// WEBPACK FOOTER //
// ./src/constants/role.js